// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2ymmS","notes":"Notes_notes__27_E0"};